import HeaderBar from "../../../Components/UI/headerbar";
import PromotionsTab from "../components/PromotionsTab";

const PromotionsPage = () => {
  return (
    <div className="container-fluid">
      <HeaderBar title="التسويق" content="إدارة الكوبونات والعروض والبانرات." />

      <div className="mt-4">
        <PromotionsTab />
      </div>
    </div>
  );
};

export default PromotionsPage;
